var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.validations
    ? _c(
        "div",
        _vm._l(_vm.validations, function(validation, index) {
          return validation.condition
            ? _c(
                "span",
                {
                  key: index,
                  staticClass: "block cl-error h6 mt8 px15",
                  attrs: { "data-testid": "errorMessage" }
                },
                [_vm._v("\n    " + _vm._s(validation.text) + "\n  ")]
              )
            : _vm._e()
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }